import React from "react";
import { observer } from "mobx-react";

import { Tooltip } from "react-tooltip";

import { Event } from "@gp/models";

export const LiveMatchTimeTooltip = observer(
	function LiveMatchTimeTooltip(props: { event: Event; tooltipId: string }) {
		const { event, tooltipId } = props;

		if (event.result?.scorePerPeriod == null) {
			return null;
		}

		return (
			<Tooltip
				id={tooltipId}
				className="at-scorePerPeriod react-tooltip--primary react-tooltip--periods"
				place="left-start"
				closeOnResize={true}
			>
				{event.result?.scorePerPeriod.map((score, idx) => {
					return (
						<div key={idx} className="react-tooltip__col">
							<div className="react-tooltip__header">
								{`P${score.periodNumber}`}
							</div>
							<div className="react-tooltip__body">
								{`${score.home ? score.home : 0}:${
									score.away ? score.away : 0
								}`}
							</div>
						</div>
					);
				})}
			</Tooltip>
		);
	}
);
